import { render, staticRenderFns } from "./FeedbackConfirmationModal.vue?vue&type=template&id=11b8278c&scoped=true"
import script from "./FeedbackConfirmationModal.vue?vue&type=script&lang=js"
export * from "./FeedbackConfirmationModal.vue?vue&type=script&lang=js"
import style0 from "./FeedbackConfirmationModal.vue?vue&type=style&index=0&id=11b8278c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b8278c",
  null
  
)

export default component.exports